import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.css'],
})
export class ProgressBarComponent implements OnInit {
  progressMiniBar1Width: number;
  progressMiniBar2Width: number;
  @Input() showValues: boolean;
  @Input() value1: number;
  @Input() value2: number;

  constructor() {
    this.progressMiniBar1Width = 0;
    this.progressMiniBar2Width = 0;
    this.showValues = false;
    this.value1 = 0;
    this.value2 = 0;
  }

  ngOnInit() {
    if (this.value1 > 0) {
      this.progressMiniBar1Width = this.value1;
    }

    if (this.value2 > 0) {
      this.progressMiniBar2Width = this.value2;
    }

    if (this.value1 < 5 && this.value2 < 5) {
      this.showValues = false;
    }
  }
}
